import React, { useState } from 'react';
import {
  Box,
  Button,
  Text,
  VStack,
  Alert,
  AlertIcon,
  Flex,
  Progress,
  useColorModeValue
} from '@chakra-ui/react';
import FileUpload from 'components/fileUploader/FileUpload';

const AdditionalDocumentUpload = ({ onUpload, isLoading }) => {
  const [files, setFiles] = useState([]);
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const handleFileChange = (newFiles) => {
    setFiles(prev => [...prev, ...newFiles]);
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleUpload = async () => {
    if (files.length === 0) return;
    
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    await onUpload(formData);
    setFiles([]); // Clear files after successful upload
  };

  return (
    <Box 
      p={6} 
      borderWidth="1px" 
      borderColor={borderColor} 
      borderRadius="md"
      bg="white"
    >
      <Alert status="info" mb={4}>
        <AlertIcon />
        Additional documents have been requested. Please upload the required documents.
      </Alert>

      <VStack spacing={4} align="stretch">
        <FileUpload
          onFileChange={(files) => handleFileChange(files)}
          buttonText="Choose Files"
          label="Upload Additional Documents"
          placeholder="No files chosen"
          helperText="Upload PDF, PNG, or JPG files (max 25MB)"
          documentType="additional_docs"
        />

        {files.length > 0 && (
          <VStack spacing={2} align="stretch">
            {files.map((file, index) => (
              <Flex
                key={index}
                p={2}
                bg="gray.50"
                borderRadius="md"
                justify="space-between"
                align="center"
              >
                <Text fontSize="sm" noOfLines={1}>
                  {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                </Text>
                <Button
                  size="sm"
                  colorScheme="red"
                  variant="ghost"
                  onClick={() => handleRemoveFile(index)}
                >
                  Remove
                </Button>
              </Flex>
            ))}
          </VStack>
        )}

        <Button
          colorScheme="purple"
          isLoading={isLoading}
          onClick={handleUpload}
          isDisabled={files.length === 0}
        >
          Upload Documents
        </Button>
      </VStack>
    </Box>
  );
};

export default AdditionalDocumentUpload;
